import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Config from 'config';
let config;
import classnames from 'classnames';
import metrics from 'lib/common/metrics';
import summaryTitle from 'lib/seats/summaryTitle';
import messagesForSeat from 'lib/seats/messagesForSeat';
import { get } from 'lodash';

import Modal from './Modal';
import SeatView from './SeatView';
import PriceTypeExisting from './PriceTypeExisting';
import PriceTypeOption from './PriceTypeOption';
import InlineSeatUpsell from './InlineSeatUpsell';
import messageFromWebContents from 'lib/seats/messageFromWebContents';
import sortBy from 'lodash/sortBy';

class SeatDetails extends Component {
  constructor(props) {
    super(props);
    config = new Config().getConfig();

    this.handleClose = this.handleClose.bind(this);
    this.handleRemoval = this.handleRemoval.bind(this);
    this.hasUpsell = this.hasUpsell.bind(this);
    this.renderSeatUpsell = this.renderSeatUpsell.bind(this);
    this.renderAvailablePrices = this.renderAvailablePrices.bind(this);

    this.convertText = this.convertText.bind(this);
  }

  handleClose() {
    const shouldDeselectOnClose = this.props.currentLineItem ? false : true;
    this.props.handleDeselection(
      this.props.selectedSeat,
      shouldDeselectOnClose
    );
  }

  handleRemoval() {
    this.props.handleRemoval(this.props.currentLineItem);
    this.handleClose();
  }

  hasUpsell() {
    return !!this.props.upsell && !this.props.currentLineItem;
  }

  convertText(text) {
    return {
      __html: text
    };
  }

  renderSeatUpsell() {
    if (this.hasUpsell()) {
      // Log Google Analytics custom event saying upsell was shown
      metrics.action(
        'Seat Upsell: Shown Upsell',
        [
          'Upsell shown from',
          this.props.upsell.referencePriceType.description,
          'to',
          this.props.upsell.seat.seatData.section_desc,
          'for performance',
          this.props.upsell.performanceId
        ].join(' ')
      );

      return (
        <div className="syos-selection__upsell">
          <InlineSeatUpsell
            upsell={this.props.upsell}
            handleSelection={this.props.onSelectUpsell}
          />
        </div>
      );
    }

    return null;
  }

  renderAvailablePrices() {
    if (this.props.priceTypes.length > 0) {
      let priceTypes = sortBy(this.props.priceTypes, x =>
        parseFloat(x.price, 10)
      );
      return (
        <ul className="u-syos-unstyled-list">
          {priceTypes.map((priceType, idx) => {
            return (
              <li key={idx}>
                <PriceTypeOption
                  priceType={priceType}
                  handleSelection={() => {
                    this.props.handleSelection(
                      this.props.selectedSeat,
                      priceType
                    );
                  }}
                />
              </li>
            );
          })}
        </ul>
      );
    } else {
      return <p>There are currently no prices available for this seat.</p>;
    }
  }

  render() {
    const { selectedSeat, seatView, currentLineItem } = this.props;
    let priceType;

    const messages = messagesForSeat(
      config.seatMessages,
      selectedSeat.seatData
    );

    let webContentMessage = messageFromWebContents(
      selectedSeat.seatData,
      get(this.props.details, 'webContent', []),
      this.props.priceTypes
    );

    if (currentLineItem) {
      priceType = {
        price_type_desc: currentLineItem.priceData.price_type_desc,
        price: currentLineItem.priceData.price
      };

      selectedSeat.seatData.zone = currentLineItem.priceData.zone_desc;
    }

    return (
      <Modal onClose={this.handleClose}>
        <div
          className={classnames({
            'syos-selection': true,
            'has-upsell': this.hasUpsell()
          })}
        >
          <div className="syos-selection__details">
            <div className="syos-seat-details">
              <h4 className="syos-seat-details__title">
                {summaryTitle(selectedSeat.seatData, this.props.zoneNames)}
              </h4>
              {seatView && seatView.image && (
                <div className="syos-seat-details__seatview">
                  <SeatView seatView={seatView} />
                </div>
              )}
              {messages.length > 0 && (
                <div className="syos-seat-details__messages">
                  {messages.map((message, key) => {
                    return <p key={key}>{message.text}</p>;
                  })}
                </div>
              )}
              {webContentMessage && (
                <div
                  className="syos-seat-details__messages"
                  dangerouslySetInnerHTML={this.convertText(webContentMessage)}
                />
              )}
              <div className="syos-seat-details__pricetypes">
                {currentLineItem ? (
                  <PriceTypeExisting
                    handleRemoval={this.handleRemoval}
                    priceType={priceType}
                  />
                ) : (
                  this.renderAvailablePrices()
                )}
              </div>
            </div>
          </div>
          {this.renderSeatUpsell()}
        </div>
      </Modal>
    );
  }
}

SeatDetails.propTypes = {
  selectedSeat: PropTypes.object.isRequired,
  seatView: PropTypes.object,
  priceTypes: PropTypes.arrayOf(PropTypes.object).isRequired,
  currentLineItem: PropTypes.object,
  handleSelection: PropTypes.func.isRequired,
  handleDeselection: PropTypes.func.isRequired,
  handleRemoval: PropTypes.func.isRequired,
  upsell: PropTypes.object,
  onSelectUpsell: PropTypes.func,
  details: PropTypes.object,
  zoneNames: PropTypes.object
};

export default SeatDetails;



// WEBPACK FOOTER //
// ./src/javascripts/components/SeatDetails.js